import styled from '@emotion/styled';
import { Title } from '@teko/ds-desktop';
import { ProductCarousel } from '@teko/teko-ecommerce';
import { ProductCardProps } from '@teko/types/ecommerce';
import { isServerless } from 'helpers';
import { t } from 'i18n';

interface ICustomRecentProductCarousel {
  recentProducts: ProductCardProps[];
}

export const CustomRecentProductCarousel = ({
  recentProducts,
}: ICustomRecentProductCarousel) => {
  if (!recentProducts.length) {
    return <></>;
  }

  return (
    <Wrapper>
      <Title>{t('Sản phẩm vừa xem')}</Title>
      <ProductCarousel
        products={recentProducts}
        productsPerRow={6.5}
        regionName="viewedItem"
        virtual={isServerless()}
        customStyleLeftArrow={arrowStyle}
        customStyleRightArrow={arrowStyle}
        desktopProps={{ perSwipe: '', bound: true }}
      />
    </Wrapper>
  );
};

const arrowStyle = {
  backgroundColor: 'white',
  borderRadius: 999,
  boxShadow: 'rgba(0, 0, 0, 0.2) 0px 5px 15px',
};

const Wrapper = styled.div`
  width: 100%;
  background-color: white;
  padding: 16px;
  border-radius: 16px;
`;
